class Graph {
  constructor(data, channels) {
    this.data = data;
    this.channels = channels;
  }

  uniqueDays() {
    return [...new Set(this.data.map((item) => item.create))];
  }

  agg(list, key) {
    if (!list.length) return;

    return list.reduce((a, b) => a + Number(b[key]), 0);
  }

  filterChannel(key) {
    return this.channels.includes(key) || this.channels.includes("ALL");
  }

  generate() {
    const uniqueDays = this.uniqueDays();
    let dataGraph = [];

    uniqueDays.map((date) => {
      let uniqueData = this.data
        .filter((item) => item.i_sms > 0 || item.i_rcs)
        .filter((item) => item.create === date);

      let subtotal = this.agg(uniqueData, "total");

      let sms = null;
      let rcs = null;

      if (this.filterChannel("SMS")) {
        sms = this.agg(uniqueData, "i_sms");
      }

      if (this.filterChannel("RCS")) {
        rcs = this.agg(uniqueData, "i_rcs");
      }

      dataGraph.push({
        subtotal,
        sms,
        rcs,
      });
    });
    return dataGraph;
  }
}

export default Graph;
